import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, IconButton, Menu, MenuItem, Stack, Typography } from '@mui/material';
import { Container } from '@mui/system';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import ActionCellPopup from '../../components/ActionCellPopup/ActionCellPopup';
import ChipLocal from '../../components/Chip/Chip';
import Link from '../../components/Link/Link';
import Progress from '../../components/Progress/Progress';
import { PATHS, countiesMapping } from '../../utils/constants';
// import ButtonPopper from '../../components/ButtonPopper/ButtonPopper';

export const LinkCell = ({ value }: any) => <Link to={PATHS.vahicle(value)}> {value} </Link>;

export const TagCell = ({ value, ...otherParams }: any) => {
  return (
    value && (
      <Box py={1}>
        <ChipLocal text={value} disabled={otherParams.disabled ?? false} sx={otherParams.sx || {}} />
      </Box>
    )
  );
};

export const ActionCell = ({ value, ...otherParams }: any) => {
  // console.log('getting toggle popper...............', otherParams);

  return (
    value && (
      <Box py={1}>
        {/* <ButtonPopper
          text={value}
          disabled={otherParams.disabled ?? false}
          sx={otherParams.sx || {}}
          actionRef={otherParams.actionRef}
          actionPopperId={otherParams.actionPopperId}
          canBeActionOpen={otherParams.canBeActionOpen}
          anchorEl={otherParams.anchorEl}
          onClickAction={otherParams.onClickAction}
          handleActionChangeType={otherParams.handleActionChangeType}
        /> */}
        <ActionCellPopup
          text={value}
          disabled={otherParams.disabled ?? false}
          sx={otherParams.sx || {}}
          handleActionChangeType={otherParams.handleActionChangeType}
        />
        {/* {otherParams.disabled === true ? (
          <Box sx={{ border: `1px solid #bbbab7`, borderRadius: 1, color: '#bbbab7', padding: '8px' }}> ... </Box>
        ) : (
          <Box
            // ref={otherParams.anchorRef}
            // size="small"
            sx={{ borderRadius: 1, border: '1px solid #456BD9', padding: '8px' }}
            onClick={() => otherParams.handleActionChangeType()}
          >
            ...
          </Box>
        )} */}
        {/* <Popper
          id={otherParams.actionPopperId}
          open={otherParams.canBeActionOpen}
          anchorEl={otherParams.anchorEl}
          transition
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              timeout={350}
              style={{
                transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
              }}
            >
              <Paper>
                <MenuList
                  autoFocusItem={otherParams.canBeActionOpen}
                  id="composition-menu"
                  aria-labelledby="composition-button"
                >
                  <MenuItem onClick={() => otherParams.handleActionChangeType()}>
                    <Typography variant="body2">Change Assignment Type</Typography>
                  </MenuItem>
                </MenuList>
              </Paper>
            </Grow>
          )}
        </Popper> */}
      </Box>
    )
  );
};

export const DateCell = ({ value }: any) => value && moment(value).format('MMM DD, YYYY');

export const ProgressCell = ({ value }: any) => <Progress progress={value} />;

type ICountryCellCellProp = {
  value: string;
};

export const CountryCell = ({ value }: ICountryCellCellProp) => {
  const [country, setCountry] = useState<string>('--');

  useEffect(() => {
    if (value) {
      const existCountry = countiesMapping.find(
        (val) => val.localeCode.split('-')[1]?.toLowerCase() === value.toLowerCase()
      );
      if (existCountry?.name) {
        setCountry(existCountry?.name);
      }
    }
  }, [value]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{country}</>;
};

export interface IVehiclePrice {
  taxAmount: number;
  taxPercentage: number;
  basePriceWithoutUpgrades: number;
  value: number;
  currency: string;
  totalBasePrice: number;
  totalPrice: number;
  locale: string;
  createdAt: Date;
  updatedAt: Date;
}

type ICurrencyDropDownCellProp = {
  value: string;
  data: any;
};

export const CurrencyDropDownCell = ({ value, data }: ICurrencyDropDownCellProp) => {
  const [vehiclePrices, setVehiclePrices] = useState<IVehiclePrice[]>([]);
  const [currentPrice, setCurrentPrice] = useState<string>('');
  const [currentLocaleCode, setCurrentLocaleCode] = useState<string>('');
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (vehiclePrice: IVehiclePrice) => {
    if (vehiclePrice.currency && vehiclePrice.totalPrice) {
      const { currency, locale } = vehiclePrice;
      setCurrentPrice(new Intl.NumberFormat('en', { style: 'currency', currency }).format(vehiclePrice.totalPrice));
      setCurrentLocaleCode(locale);
    }
    setAnchorEl(null);
  };

  useEffect(() => {
    if (data.vehiclePrice && data.vehiclePrice.length > 0) {
      const vehiclePricesData: IVehiclePrice[] = data.vehiclePrice;
      let currentValue: IVehiclePrice | undefined;
      if (data.transitCountry) {
        currentValue = vehiclePricesData.find((val: IVehiclePrice) => {
          return val.locale.split('-')[1].toLowerCase() === data.transitCountry.toLowerCase();
        });
      }

      if (!currentValue) {
        const existCountry = countiesMapping.find((val) => val.name.toLowerCase() === data.country.toLowerCase());
        currentValue = vehiclePricesData.find((val: IVehiclePrice) => {
          return val.locale.split('-')[1].toLowerCase() === existCountry?.locale.toLowerCase();
        });
      }

      if (!currentValue) {
        const [first] = vehiclePricesData;
        currentValue = first;
      }

      const { currency, locale } = currentValue;

      const seen = new Set();
      const filteredVehiclePrices = vehiclePricesData.filter((val) => {
        if (val.locale) {
          const duplicate = seen.has(val.locale.split('-')[1]);
          seen.add(val.locale.split('-')[1]);
          return !duplicate;
        }
        return false;
      });

      setVehiclePrices(filteredVehiclePrices);
      setCurrentPrice(new Intl.NumberFormat('en', { style: 'currency', currency }).format(currentValue.totalPrice));
      setCurrentLocaleCode(locale);
    }
  }, [data]);

  return (
    <Container>
      {vehiclePrices && vehiclePrices.length > 0 ? (
        <Stack justifyContent="flex-end" alignContent="center" direction="row" spacing={1}>
          <Box>{currentPrice}</Box>
          <Typography variant="overline" color="primary.main" style={{ paddingTop: 2 }}>
            {currentLocaleCode ? new Intl.Locale(currentLocaleCode.toLowerCase()).region : ''}
            <IconButton
              color="info"
              size="small"
              aria-label="more"
              id="long-button"
              aria-controls={open ? 'long-menu' : undefined}
              aria-expanded={open ? 'true' : undefined}
              aria-haspopup="true"
              onClick={handleClick}
            >
              <KeyboardArrowDownIcon />
            </IconButton>
            <Menu
              id="long-menu"
              MenuListProps={{
                'aria-labelledby': 'long-button',
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
            >
              {vehiclePrices.map((vehiclePrice) => (
                <MenuItem
                  key={vehiclePrice.locale}
                  selected={vehiclePrice.locale === currentLocaleCode}
                  onClick={() => handleClose(vehiclePrice)}
                >
                  {new Intl.Locale(vehiclePrice.locale.toLowerCase()).region}
                </MenuItem>
              ))}
            </Menu>
          </Typography>
        </Stack>
      ) : (
        '--'
      )}
    </Container>
  );
};
